import { FC } from "react";
import {
  ReportEmployeeSalesCommissionSearchPanel,
  ReportPage,
} from "../../../components";
import {
  getPageNameByPageId,
  getSystemLanguageId,
  getUserId,
} from "../../../utils";
import {
  EmployeeSalesCommissionReportSearchParamsModel,
  PageEnum,
} from "../../../models";
import { searchReportEmployeeSalesCommission } from "../../../serviceBroker/employeeReportApiServiceBroker";

export const ReportEmployeeSalesCommissionPage: FC = () => {
  const initialState: EmployeeSalesCommissionReportSearchParamsModel = {
    Lang: getSystemLanguageId(),
  };
  return (
    <ReportPage
      InitialState={initialState}
      SearchApi={searchReportEmployeeSalesCommission}
      searchHeader={getPageNameByPageId(
        PageEnum.ReportEmployeeCommissionFromSales
      )}
      SearchPanel={ReportEmployeeSalesCommissionSearchPanel}
      formId={PageEnum.ReportEmployeeCommissionFromSales}
    />
  );
};
